import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SearchRecurringBenefitModel } from '../models/search-recurring-benefit.model';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReportService } from '../../services/report/report.service';
import { RecurringBenefitsModel } from '../models/recurring-benefits-model';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-recurring-benefits-history',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './recurring-benefits-history.component.html',
  styleUrl: './recurring-benefits-history.component.scss',
})
export class RecurringBenefitsHistoryComponent implements OnInit {
  searchForm: FormGroup;
  user: ILoggedInUser;
  isReportRight: boolean = false;
  isLoading: boolean = false;
  isLoadingExcel: boolean = false;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'employee', 'lineType', 'description', 'amount', 'cycle', 'dateCollected'];
  searchRequestParams: SearchParameters<SearchRecurringBenefitModel>;
  pagedData: PagedResult<RecurringBenefitsModel[]>;
  dataSource: MatTableDataSource<RecurringBenefitsModel>;
  recurringLineTypes = [];

  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private reportService: ReportService ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      employeeName: new FormControl(''),          
      lineType: new FormControl(''),
      fromDate: new FormControl(''),
      toDate: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user !== null && this.user.reportRight){
        this.isReportRight = this.user.reportRight;        
      }      
    });
    
    this.reportService.getRecurringLineTypes().subscribe({
      next: (data) => {
        this.recurringLineTypes = data;
      },
      error: (error) => {
      },
    });
  }

  search() {
    if(this.isReportRight){
      this.isLoading = true;
      this.reportService.searchRecurringBenefits(this.searchRequestParams)
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<RecurringBenefitsModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<RecurringBenefitsModel>([]);
    }
  }

  submitForm(): void { 
    this.searchRequestParams = {
      query: {
        employeeName: this.searchForm.get('employeeName').value || null,
        lineType: this.searchForm.get('lineType').value || null,
        fromDate: this.searchForm.get('fromDate').value || null,
        toDate: this.searchForm.get('toDate').value || null
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };
    this.search();
  }

  public pageChangeEvent(event?: PageEvent){
    this.searchRequestParams.pageIndex = event.pageIndex;
    this.searchRequestParams.pageSize = event.pageSize;
    this.search();
  }  

  exportAllToExcel(){
    var searchParams = this.searchRequestParams;
    searchParams.pageSize = this.totalCount;
    this.isLoadingExcel = true;
    this.reportService.searchRecurringBenefits(searchParams).subscribe(data => {
      this.exportToExcel(data.items);
      this.isLoadingExcel = false;
    });
  }


  exportToExcel(data : RecurringBenefitsModel[]){
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'recurring-benefits');
    XLSX.writeFile(wb, 'Recurring-Benefits.xlsx');
  }
  
}
